/* eslint-disable react/no-unescaped-entities */
import { AbdooLogo, b2cPolicies, shareAbdooLink } from '@abdoo/common';
import { msalInstance } from '@abdoo/common';
import { Grid, Typography } from '@mui/material';
import React, { useCallback } from 'react';
import { useLocation } from 'react-router-dom';

import { ApproveReject } from '../ApproveReject/ApproveReject';
import { ApproveRejectCancellation } from '../ApproveRejectCancellation/ApproveRejectCancellation';
import abdooLogo from '../logos/Abdoo logo_64px-height.png';
import { ManagerLandingPageTile } from '../Manager/ManagerLandingPageTile';
import employeeTilePhoto from './employeeTilePhoto.png';
import { InvitationEmailContent } from './invitationEmailContent';
import { ManagerLandingPageTileProps } from './ManagerLandingPageTile';
import managerTilePhoto from './managerTilePhoto.png';
import registeredManagerTilePhoto from './registeredManagerTilePhoto.png';

export const ManagerLandingPage = () => {
  const search = useLocation().search;
  const action = new URLSearchParams(search).get('action')?.toLocaleLowerCase();
  const bookingId = new URLSearchParams(search).get('bookingId');
  const shareId = new URLSearchParams(search).get('share');

  const redirectToSignUpPage = useCallback(() => {
    msalInstance.loginRedirect(b2cPolicies.authorities.Signup);
  }, []);

  const openMailWithInvitation = useCallback(() => {
    window.location.href = `mailto:?subject=${InvitationEmailContent.subject}&body=${InvitationEmailContent.body}`;
  }, []);

  const share = useCallback(() => shareAbdooLink(shareId ?? ''), [shareId]);

  if (bookingId === null) {
    // TODO: Handle UI Scenario
    return (
      <>
        <AbdooLogo src={abdooLogo} sx={{ height: '2.25em' }} />
        <Typography align="center">No booking id found</Typography>
      </>
    );
  }

  const actionsComponents = {
    approve: <ApproveReject bookingId={bookingId} approveOrReject="approve" />,
    reject: <ApproveReject bookingId={bookingId} approveOrReject="reject" />,
    approvecancellation: (
      <ApproveRejectCancellation bookingId={bookingId} approveOrReject="approve" />
    ),
    rejectcancellation: (
      <ApproveRejectCancellation bookingId={bookingId} approveOrReject="reject" />
    ),
  };

  const actionAsKey = action as keyof typeof actionsComponents;

  const managerTileProps: ManagerLandingPageTileProps = {
    title: 'Are you a manager?',
    subtitle: (
      <span>
        Streamline your team's holiday management process with <b>Abdoo</b>!
      </span>
    ),
    description: (
      <span>
        Ditch the traditional paperwork and embrace a modern approach. By using{' '}
        <b>Abdoo</b>, you can efficiently handle holiday requests from your employees and
        provide quick responses.Simplify your workload and empower your team members to
        take charge of their own holiday planning. Experience the benefits of <b>Abdoo</b>{' '}
        now!
      </span>
    ),
    footerButtonCaption: (
      <span>
        Invite your other reports to use <b>Abdoo</b>
      </span>
    ),
    photoPath: managerTilePhoto,
    onFooterButtonClick: openMailWithInvitation,
  };

  const employeeTileProps: ManagerLandingPageTileProps = {
    title: 'Are you an employee?',
    subtitle: (
      <span>
        Take control of your time off with <b>Abdoo</b>!
      </span>
    ),
    description: (
      <span>
        Say goodbye to manual paperwork and endless email threads. Start using{' '}
        <b>Abdoo</b> today to easily submit holiday requests, track your leave history,
        and stay organised. Take charge of your work-life balance and enjoy hassle-free
        holiday management. Sign up now!
      </span>
    ),
    footerButtonCaption: (
      <span>
        Sign up for a free <b>Abdoo</b> account now
      </span>
    ),
    photoPath: employeeTilePhoto,
    onFooterButtonClick: redirectToSignUpPage,
  };

  const registeredManagerTileProps: ManagerLandingPageTileProps = {
    title: 'Abdoo is better with others',
    subtitle: <></>,
    description: (
      <span>
        <b>Abdoo</b> is a powerful and easy-to-use absence management system that helps
        you keep track of your team’s leave requests, approvals, and balances. But did you
        know that <b>Abdoo</b> is also better with others? You can share <b>Abdoo</b> with
        other direct reports that you manage, friends, partner, or anyone else who needs a
        simple and effective way to manage absence.
      </span>
    ),
    footerButtonCaption: <span>Share</span>,
    photoPath: registeredManagerTilePhoto,
    onFooterButtonClick: share,
  };

  return (
    <>
      <AbdooLogo src={abdooLogo} sx={{ height: '2.25em' }} />
      <Grid
        container
        justifyContent="center"
        rowGap={4}
        flexDirection="column"
        alignContent="center"
        alignItems="center"
      >
        <Grid item>
          <Typography align="center">
            <Grid container>{actionAsKey ? actionsComponents[actionAsKey] : null}</Grid>
          </Typography>
        </Grid>
        <Grid container xs={12} sx={{ marginBottom: '2rem' }}>
          <Grid container justifyContent="center" spacing={5} flexDirection="row">
            {!shareId && (
              <>
                <ManagerLandingPageTile {...managerTileProps}></ManagerLandingPageTile>
                <ManagerLandingPageTile {...employeeTileProps}></ManagerLandingPageTile>
              </>
            )}
            {shareId && (
              <ManagerLandingPageTile
                {...registeredManagerTileProps}
              ></ManagerLandingPageTile>
            )}
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};
